module.exports = __webpack_public_path__ + "img/100x75.ec5a4dd1.png";